export interface CompactSegmentedOption<T extends string> {
    key: T;
    label: string;
}

// Track height (border + padding + h-6 button); rows that must line up with the toggle reuse it.
export const COMPACT_SEGMENTED_TOGGLE_HEIGHT_CLASS = 'h-[30px]';

interface CompactSegmentedToggleProps<T extends string> {
    options: readonly CompactSegmentedOption<T>[];
    active: T;
    onChange: (next: T) => void;
    ariaLabel: string;
}

// Small in-card segmented toggle, the compact sibling of RangeControl.
export function CompactSegmentedToggle<T extends string>({
    options,
    active,
    onChange,
    ariaLabel
}: CompactSegmentedToggleProps<T>) {
    return (
        <div
            role="group"
            aria-label={ariaLabel}
            className={`flex ${COMPACT_SEGMENTED_TOGGLE_HEIGHT_CLASS} items-center bg-gray-100 border border-gray-200 rounded-lg p-0.5`}
        >
            {options.map((option) => (
                <button
                    key={option.key}
                    type="button"
                    aria-pressed={option.key === active}
                    onClick={() => onChange(option.key)}
                    className={`px-2.5 h-6 rounded-md text-[11px] font-semibold transition-colors ${
                        option.key === active
                            ? 'bg-white text-gray-900 shadow-sm'
                            : 'text-gray-500 hover:text-gray-700'
                    }`}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
}
